module.exports = "/_next/static/images/game-1-phone-gallery-08-25-1502-uv-e5e6e72f399c97a641d46609283daced.jpg";